import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { RFQFormItemResponse } from '../models/rfq';
import { inject } from '@angular/core';
import { RfqService } from '../services/rfq/rfq.service';
import { RFQState } from '../constants/rfqStates.constant';
import { NavigationPipe } from '../pipes/navigation/navigation.pipe';
import { Path } from '../constants/paths.constant';
import { tap } from 'rxjs';

const isRfqFormRoute = (route: ActivatedRouteSnapshot): boolean =>
  route.url.some(segment => segment.toString() === Path.RFQ.FORM);

const isRfqDetailsViewRoute = (route: ActivatedRouteSnapshot): boolean =>
  route.url.some(segment => segment.toString() === Path.RFQ.DETAILS);

const navigateToRfqBoard = (
  router: Router,
  navigationPipe: NavigationPipe,
  userType: 'buyer' | 'supplier'
): void => {
  router.navigate([navigationPipe.transform(`${userType}/${Path.RFQ.RFQ}`)]);
};

export const rfqDetailsResolver: ResolveFn<RFQFormItemResponse | undefined> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const navigationPipe = new NavigationPipe();
  const router = inject(Router);
  const rfqId = route.params['rfqId'];
  const userType = route.data['role'];
  const getDetails =
    inject(RfqService)[
      userType === 'buyer' ? 'getRFQById' : 'getSupplierReceivedRFQById'
    ](rfqId);

  if (rfqId) {
    return getDetails.pipe(
      tap(res => {
        if (
          !res.rfq ||
          (isRfqFormRoute(route) && res.rfq?.state?.name !== RFQState.DRAFT) ||
          (isRfqDetailsViewRoute(route) &&
            res.rfq?.state?.name === RFQState.DRAFT)
        )
          navigateToRfqBoard(router, navigationPipe, userType);
      })
    );
  } else {
    return undefined;
  }
};
